import { environment } from '../../../environments/environment';
import { FileDownloadService } from '../../products/file-download.service';
import { FavoritesService } from '../../products/favorites.service';
import { ConfigurationService } from '../../configuration.service';
import { LoginReminderModalComponent } from '../../login-reminder-modal/login-reminder-modal.component';
import { MatDialog } from '@angular/material';
var SlideComponent = /** @class */ (function () {
    function SlideComponent(fd, favoritesService, dialog, configurationService) {
        this.fd = fd;
        this.favoritesService = favoritesService;
        this.dialog = dialog;
        this.configurationService = configurationService;
        this.imageBase = "";
        this.config = { license: '' };
        this.filesize = 0;
        // @Input()
        // config:Configuration = {license: ''};
        this.favourited = false;
        this.thumbObj = {};
        this.imageBase = "" + environment.imageBase;
        this.config = configurationService.getConfigurationCache();
    }
    Object.defineProperty(SlideComponent.prototype, "item", {
        get: function () {
            // other logic
            return this._item;
        },
        set: function (value) {
            this.filesize = (value.file_size / 1000000);
            if (this.filesize < 1) {
                value.filesize = '< 1 MB';
            }
            else {
                value.filesize = Math.round(this.filesize) + " MB";
            }
            value.categoryString = (value.category) ? value.category.reduce(function (a, b) {
                return a + ' / ' + b.title;
            }, '') : '';
            if (!value.category) {
                this.favourited = true;
            }
            // style="background: url({{imageBase}}{{imageSrc}})" 100% auto
            this.thumbObj = {
                'background': "url(" + (environment.imageBase + this.imageSrc) + ") no-repeat top center",
                'background-size': 'contain',
                //flex: `1 0 ${this.thumbHeight || 150}px`
                flex: "1 0 150px"
            };
            this._item = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SlideComponent.prototype, "isHdr", {
        get: function () {
            if (this.imageSrc) {
                var imageParts = this.imageSrc.split('.');
                if (imageParts[1])
                    return imageParts[1] == 'hdr';
            }
            else {
                return false;
            }
        },
        enumerable: true,
        configurable: true
    });
    SlideComponent.prototype.favouriteItem = function (event) {
        var _this = this;
        var favourite = !this.favourited;
        this.favoritesService.favoriteToggle(this.item, favourite)
            .subscribe(function (result) {
            _this.favourited = result;
        });
    };
    SlideComponent.prototype.openUpLicense = function (event) {
        var dialogRef = this.dialog.open(LoginReminderModalComponent, {});
    };
    SlideComponent.prototype.fileDownload = function (event) {
        console.log(event);
        if (this.item.type === 'free' || (this.config && this.config.license != '' && this.config.license != null)) {
            this.fd.fetchProduct(this.item, this.config)
                .subscribe(function (results) {
                console.log('file download', results);
            }, function (err) { return console.error(err); }, function () { return console.log('done loading services x'); });
        }
        else {
            console.log('not logged in so canot download');
        }
    };
    SlideComponent.prototype.ngOnInit = function () {
        // console.log('this.config', this.config)
        var _this = this;
        this.configurationService.getConfigurationSubject()
            .subscribe(function (config) {
            _this.config = config;
        });
    };
    return SlideComponent;
}());
export { SlideComponent };



// WEBPACK FOOTER //
// ./src/app/product-carousel/slide/slide.component.ts.pre-build-optimizer.js